import { createFileRoute } from '@tanstack/react-router';
import { TagList } from '@/components/tags/TagList.tsx';

export const Route = createFileRoute('/$spaceSlug/tags')({
  component: RouteComponent,
  head: () => ({
    meta: [
      {
        title: 'Findya | Tags',
      },
    ],
  }),
});

function RouteComponent() {
  return (
    <div className="flex grow overflow-hidden mx-auto max-w-[900px] w-full">
      <TagList />
    </div>
  );
}
